import * as collections from '../seeds/collections';

const MODEL_NAME = collections.bookingFiles.model_name;
const COLLECTION_NAME = collections.bookingFiles.name;

export function getOrCreateBookingFile(service, opts = {}) {
  const { reference, customer } = opts;
  if (!reference) { return insertBookingFile(service, { id: 0, customer }, false); }
  return findBookingFile(service, reference)
    .then(bf => {
      if (bf) { return bf; }
      return insertBookingFile(service, { id: 0, reference, customer }, false);
    });
}

function insertBookingFile(service, data, asGraphQL = true) {
  const objectData = asGraphQL ? data : { [COLLECTION_NAME]: [data] };
  if (!objectData[COLLECTION_NAME][0].reference) objectData[COLLECTION_NAME][0].reference = generateReference();
  return service.insertObject(COLLECTION_NAME, objectData);
}

export function generateReference() {
  return Math.floor((Date.now()/5)+(2000*Math.random()) - 52000000000).toString(32).toUpperCase();
}

function findBookingFile(service, reference) {
  const queryOptions = [['*'], { where: { reference } }];
  return service.fetchObjects([COLLECTION_NAME].concat(queryOptions))
    .then(res => res[COLLECTION_NAME][0]);
}



// WEBPACK FOOTER //
// ./src/backend/daily-rental/api/bookingFile.js